<template lang="pug">
  .row
    edit_sending_school_modal(
      v-if="currentModal.show",
      :modal="currentModal",
      :schools="schools",
      :registration="registration",
      @name-selected="handleNameSelected(currentModalType, $event)"
    )
    .columns.large-24
      article.content-block
        header
          .title.title-with-button
            | {{ t('app.registration.transfer_request.title') }}
        .content
          .row
            .form-col.large-24
              span.required *
              validation-provider( 
                :rules="{ required: registration.accept_transfer == null }"
                v-slot="{ errors }"
                ref="accept_transfer"
              )
                label(:class="{ error: errors[0] }")
                  | {{ registration.program.student_transfer_questions.question }}

                .checkbox-group
                  .checkbox-field2
                    label(for="yes_transfer" :class="{ error: errors[0] }")
                      input(
                        type="radio"
                        name="accept_transfer"
                        class="no-custom"
                        id="yes_transfer"
                        value="enable"
                        :disabled="registration.program.organization.student_transfer"
                        @change="onTransferChange($event)"
                        :checked="registration.accept_transfer === false"
                      )
                      span.label-text {{ t('app.general._yes') }}

                  .checkbox-field2
                    label(for="no_transfer" :class="{ error: errors[0] }")
                      input(
                        type="radio"
                        name="accept_transfer"
                        class="no-custom"
                        id="no_transfer"
                        value="disable"
                        :disabled="registration.program.organization.student_transfer"
                        @change="onTransferChange($event)"
                        :checked="registration.accept_transfer === true"
                      )
                      span.label-text {{ t('app.general._no') }}

            .transfer-information(v-if="transfer_block")
              label.transfer-information-text {{'Transfer Information'}}
              .form-col.large-24(v-if="get_date_entered_9th_grade")
                span.required(v-if="get_date_entered_9th_grade.required") *
                validation-provider.field.clearfix.datepicker( 
                  v-slot="{ errors }"
                  :rules="{ required: get_date_entered_9th_grade.required }"
                  tag="div"
                  ref="date_participant_entered_9th_grade"
                )
                  label(:class="{error: errors[0]}")
                      | {{ get_date_entered_9th_grade.name }}
                  span.description(v-if="get_date_entered_9th_grade.description")
                        | {{get_date_entered_9th_grade.description}}
                  .input-group
                    flat-pickr(
                      placeholder="mm-dd-yyyy"
                      v-model="registration.registration_transfers.accept_transfer_no_data.date_participant_entered_9th_grade"
                      class="large-6"
                      :config="datePickerOpts"
                    )
                    .prefix.date
                      span.icon-calendar
              .form-col.large-24
                span.required *
                validation-provider(:rules="{ required: registration.registration_transfers.homeschooled_last_year == null }" v-slot="{ errors }" ref="homeschooled_last_year")
                  label(:class="{ error: errors[0] }") Was the participant homeschooled last year?
                  .checkbox-field2
                    label(for="yes_homeschooled" :class="{ error: errors[0] }")
                      input(
                        type="radio"
                        name="homeschooled_last_year"
                        class="no-custom"
                        value="yes"
                        id="yes_homeschooled"
                        @change="onHomeschooledChange($event)"
                        :checked="registration.registration_transfers.homeschooled_last_year === true"
                      )
                      span.label-text {{ t('app.general._yes') }}
                  .checkbox-field2
                    label(for="no_homeschooled" :class="{ error: errors[0] }")
                      input(
                        type="radio"
                        name="homeschooled_last_year"
                        class="no-custom"
                        value="no"
                        id="no_homeschooled"
                        @change="onHomeschooledChange($event)"
                        :checked="registration.registration_transfers.homeschooled_last_year === false"
                      )
                      span.label-text {{ t('app.general._no') }}

              template(v-if="showAdditionalFields")
                .form-col.large-24 
                  label {{ 'Upload most recent transcript and other documentation' }}
                  TranscriptUploadFile(:model_data="registration.registration_transfers.homeschooled_last_year_yes_data")
                .form-col.large-24(v-if="get_sending_school_end_date.active")
                  .form-col.large-24(
                    v-if="showAdditionalFields && registration.registration_transfers.homeschooled_last_year === true"
                  )
                    validation-provider.field.clearfix.datepicker( 
                      v-slot="{ errors }"
                      :rules="{ required: get_sending_school_end_date.required }"
                      tag="div"
                      ref="withdrawal_date_validation_yes"
                    )
                      span.required(v-if="get_sending_school_end_date.required") *
                      label(:class="{ error: errors[0] }")
                        | {{ get_sending_school_end_date.name }}
                      span.description(v-if="get_sending_school_end_date.description")
                        | {{get_sending_school_end_date.description}}
                      .input-group
                        flat-pickr(
                          placeholder="mm-dd-yyyy"
                          v-model="registration.registration_transfers.homeschooled_last_year_yes_data.withdrawal_date.date"
                          class="large-6"
                          :config="datePickerOpts"
                          @input="onSelectDate($event, 'yes_withdrawal')"
                        )
                        .prefix.date
                          span.icon-calendar      
                .form-col.large-24
                  span.required *
                  validation-provider(:rules="{ required: registration.registration_transfers.is_participant_seeking_to_participate == null }" v-slot="{ errors }" ref="is_participant_seeking_to_participate")
                    label(:class="{ error: errors[0] }") {{ t('app.registration.transfer_info.seeking_to_participate') }}

                    .checkbox-field2
                      label(:for="'yes_seeking_to_participate'" :class="{ error: errors[0] }")
                        input(
                          type="radio"
                          name="is_participant_seeking_to_participate"
                          class="no-custom"
                          value="yes"
                          :id="'yes_seeking_to_participate'"
                          @change="onSeekingToParticipateChange($event)"
                          :checked="registration.registration_transfers.is_participant_seeking_to_participate === true"
                        )
                        span.label-text {{ t('app.general._yes') }}

                    .checkbox-field2
                      label(:for="'no_seeking_to_participate'" :class="{ error: errors[0] }")
                        input(
                          type="radio"
                          name="is_participant_seeking_to_participate"
                          class="no-custom"
                          value="no"
                          :id="'no_seeking_to_participate'"
                          @change="onSeekingToParticipateChange($event)"
                          :checked="registration.registration_transfers.is_participant_seeking_to_participate === false"
                        )
                        span.label-text {{ t('app.general._no') }}

              template(v-if="showAdditionalNoFields")
                .form-col.large-24(v-if="get_previous_school_name_and_address.active")
                  validation-provider(
                    name="previous_school"
                    v-slot="{ errors }"
                    :rules="previousSchoolRules"
                    ref="previous_school"
                  )
                    span.required(v-if="get_previous_school_name_and_address.required") *
                    label(
                      :id="'select-previous-school-label'"
                      :class="{ error: (errors[0] && !previousSelectedName) || (!previousSelectedName && isPreviousSchoolClicked) }"
                    )
                      | {{ get_previous_school_name_and_address.name }}
                    span.description(v-if="get_previous_school_name_and_address.description")
                      | {{ get_previous_school_name_and_address.description }}
                    .row.show_list
                      a.button(
                        @click="openSchoolModal('previous')"
                        v-if="!previousSelectedName"
                        :class="{ 'school-error': (!previousSelectedName && isPreviousSchoolClicked) || errors[0] }"
                      ) Select School
                      
                      .school_name(v-if="previousSelectedName")
                        .name-wrapper
                          .name {{ previousSelectedName.name }}
                          .remove_name
                            span.icon-trash.lists(@click="clearSelectedName('previous')")
                        .address {{ previousSelectedName.address }},
                        .addressline2  {{ previousSelectedName.city }}, {{ previousSelectedName.state }} {{ previousSelectedName.postalCode }}
                
                .form-col.large-24(v-if="get_sending_school_end_date.active")
                  validation-provider.field.clearfix.datepicker(
                    v-slot="{ errors }"
                    :rules="{ required: get_sending_school_end_date.required }"
                    tag="div"
                    ref="withdrawal_date_validation_no"
                  )
                    span.required(v-if="get_sending_school_end_date.required") *
                    label(:class="{ error: errors[0] }")
                      | {{ get_sending_school_end_date.name }}
                    span.description(v-if="get_sending_school_end_date.description")
                        | {{ get_sending_school_end_date.description }}
                    .input-group
                      flat-pickr(
                        placeholder="mm-dd-yyyy"
                        v-model="registration.registration_transfers.homeschooled_last_year_no_data.withdrawal_date.date"
                        class="large-6"
                        :config="datePickerOpts"
                        @input="onSelectDate($event, 'no_withdrawal')"
                      )
                      .prefix.date
                        span.icon-calendar

                .form-col.large-24(v-if="get_receiving_school_name_and_address.active")
                  validation-provider(v-slot="{ errors }" :rules="receivingSchoolParticipantRules" ref="receiving_school")                        
                    span.required(v-if="get_receiving_school_name_and_address.required") *
                    label(
                      :id="'select-receiving-school-label'",
                      :class="{ error: (errors[0] && !receivingSelectedName) || (!receivingSelectedName && isReceivingSchoolClicked) }"
                    )
                      | {{ get_receiving_school_name_and_address.name }}
                    span.description(v-if="get_receiving_school_name_and_address.description")
                        | {{ get_receiving_school_name_and_address.description }}
                    .row.show_list                            
                      a.button(
                        @click="openSchoolModal('receiving')",
                        v-if="!receivingSelectedName",
                        :class="{ 'school-error': (!receivingSelectedName && isReceivingSchoolClicked) || errors[0] }"
                      ) Select School
                      .school_name(v-if="receivingSelectedName")
                        .name-wrapper
                          .name {{ receivingSelectedName.name }}
                          .remove_name
                            span.icon-trash.lists(@click="clearSelectedName('receiving')")
                        .address {{ receivingSelectedName.address }},
                        .addressline2  {{ receivingSelectedName.city }}, {{ receivingSelectedName.state }} {{ receivingSelectedName.postalCode }}                             
                .form-col.large-24(v-if="get_date_of_enrollment_at_receiving_school.active")
                  validation-provider.field.clearfix.datepicker( 
                    v-slot="{ errors }"
                    :rules="{ required: get_date_of_enrollment_at_receiving_school.required }"
                    tag="div"
                    ref="date_of_enrollment_at_receiving_school_homeschooled_no"
                  )
                    span.required(v-if="get_date_of_enrollment_at_receiving_school.required") *
                    label(:class="{ error: errors[0] }")
                      | {{ get_date_of_enrollment_at_receiving_school.name }}
                      br
                    span.description(v-if="get_date_of_enrollment_at_receiving_school.description")
                        | {{ get_date_of_enrollment_at_receiving_school.description }}
                    .input-group
                      flat-pickr(
                        placeholder="mm-dd-yyyy"
                        v-model="registration.registration_transfers.homeschooled_last_year_no_data.enrollment_date.date"
                        class="large-6"
                        :config="datePickerOpts"
                        @input="onSelectDate($event, 'enrollment')"
                      )
                      .prefix.date
                        span.icon-calendar

              .form-col.large-24(v-if="registration.registration_transfers.is_participant_seeking_to_participate == false && !showAdditionalNoFields")
                .form-col.large-24(v-if="get_receiving_school_name_and_address.active")
                  validation-provider(
                    name="receiving_school"
                    v-slot="{ errors }"
                    :rules="receivingSchoolRules"
                  )
                    span.required(v-if="get_receiving_school_name_and_address.required") *
                    label(
                      :id="'select-receiving-school-label'",
                      :class="{ error: (errors[0] && !receivingSelectedNameOnParticipantSeeking) || (!receivingSelectedNameOnParticipantSeeking && isReceivingSchoolClickedOnIsNotParticipantSeeking) }"
                    )
                      | {{ get_receiving_school_name_and_address.name }}
                    span.description(v-if="get_receiving_school_name_and_address.description")
                        | {{ get_receiving_school_name_and_address.description }}
                    .row.show_list                            
                      a.button(
                        @click="openSchoolModal('is_not_participant_seeking_receiving')",
                        v-if="!receivingSelectedNameOnParticipantSeeking",
                        :class="{ 'school-error': (!receivingSelectedNameOnParticipantSeeking && isReceivingSchoolClickedOnIsNotParticipantSeeking) || errors[0] }"
                      ) Select School        
                      .school_name(v-if="receivingSelectedNameOnParticipantSeeking")
                        .name-wrapper
                          .name {{ receivingSelectedNameOnParticipantSeeking.name }}
                          .remove_name
                            span.icon-trash.lists(@click="clearSelectedName('is_not_participant_seeking_receiving')")
                        .address {{ receivingSelectedNameOnParticipantSeeking.address }},
                        .addressline2  {{ receivingSelectedNameOnParticipantSeeking.city }}, {{ receivingSelectedNameOnParticipantSeeking.state }} {{ receivingSelectedNameOnParticipantSeeking.postalCode }}                             
                      
              .form-col.large-24(v-if="get_date_of_enrollment_at_receiving_school.active && registration.registration_transfers.is_participant_seeking_to_participate == false && !showAdditionalNoFields")
                validation-provider.field.clearfix.datepicker(v-slot="{ errors }" :rules="{required: get_date_of_enrollment_at_receiving_school.required}" tag="div")
                  span.required(v-if="get_date_of_enrollment_at_receiving_school.required") *
                  label(:class="{ error: errors[0] }")
                    | {{ get_date_of_enrollment_at_receiving_school.name }}
                  span.description(v-if="get_date_of_enrollment_at_receiving_school.description")
                    | {{ get_date_of_enrollment_at_receiving_school.description }}
                  .input-group
                    flat-pickr(
                      placeholder="Select",
                      v-model="registration.registration_transfers.participant_seeking_no_data.enrollment_date",
                      class="large-6"
                      :config="datePickerOpts"
                      @input="onSelectDate($event, 'enrollment')"
                    )
                    .prefix.date
                      span.icon-calendar
              .form-col.large-24(v-if="registration.registration_transfers.is_participant_seeking_to_participate == true && !showAdditionalNoFields")
                span.required *
                validation-provider(rules="required" v-slot="{ errors }")
                  label(:class="{ error: errors[0] }") {{ t('app.registration.transfer_info.school_district_address') }}
                  input(type="text" placeholder="Enter School District" v-model="registration.registration_transfers.participant_seeking_yes_data.school_district_address" :class="{ error: errors[0] }")
              .form-col.large-24(v-if="registration.registration_transfers.is_participant_seeking_to_participate == false && !showAdditionalNoFields")
                span.required *
                validation-provider(rules="required" v-slot="{ errors }")
                  label(:class="{ error: errors[0] }") {{ t('app.registration.transfer_info.school_district_address') }}
                  input(type="text" placeholder="Enter School District" v-model="registration.registration_transfers.participant_seeking_no_data.school_district_address" :class="{ error: errors[0] }")
              .transfer-information(
                v-if="renderedReason"
              )
                TransferNewRequestReason(
                  :activeReasons="activeReasons"
                  :registration="registration"
                  :registration_transfers_data="renderedReason.dataKey"
                  :question_type="renderedReason.questionType"
                  :reason_data="registration.registration_transfers[renderedReason.dataKey]"
                  :transfer_info="participants"
                )

              .varsity-information(v-if="get_varsity_participation.active && (registration.registration_transfers.is_participant_seeking_to_participate == true || registration.registration_transfers.homeschooled_last_year == false || registration.registration_transfers.is_participant_seeking_to_participate == false)")
                label.transfer-information-text {{ t('app.registration.transfer_info.varsity_participation') }}
                .form-col.large-24
                  span.required(v-if="get_varsity_participation.required") *
                  validation-provider(:rules="{ required: get_varsity_participation.required }" v-slot="{ errors }" ref="is_varsity_participation")
                    label(:class="{ error: errors[0] }") {{ get_varsity_participation.name }}
                    span.description(v-if="get_varsity_participation.description")
                          | {{ get_varsity_participation.description }}
                    .checkbox-field2
                      label(:for="'yes_varsity_participate'" :class="{ error: errors[0] }")
                        input(
                          type="radio"
                          name="is_varsity_participation"
                          class="no-custom"
                          :value="true"
                          :id="'yes_varsity_participate'"
                          v-model="varsityParticipation"
                          @change="onVarsityToParticipateChange"
                        )
                        span.label-text {{ t('app.general._yes') }}
                    .checkbox-field2
                      label(:for="'no_varsity_participate'" :class="{ error: errors[0] }")
                        input(
                          type="radio"
                          name="is_varsity_participation"
                          class="no-custom"
                          :value="false"
                          :id="'no_varsity_participate'"
                          v-model="varsityParticipation"
                          @change="onVarsityToParticipateChange"
                        )
                        span.label-text {{ t('app.general._no') }}

              <template v-if="registration.registration_transfers.is_varsity_participation === true">
                VarsityInfoSection(v-if="get_varsity_sports_played.active" :varsity_info="registration.registration_transfers.varsity_participation_yes_data" :required="get_varsity_sports_played.required" :nested_fields="get_varsity_participation.nested_fields")
                ParticipantAddressSection(:varsity_info="registration.registration_transfers.varsity_participation_yes_data" :nested_fields="get_participant_nested_fields")
                HouseholdMembersInput(:varsity_info="registration.registration_transfers.varsity_participation_yes_data" :required="get_people_participant_lived_with.required" :nested_fields="get_participant_nested_fields")      
              </template>
              NotesAndAgreement(
                :agreementsInfo="registration.registration_transfers.agreements_data"
              )
</template>
<script>
import datepicker from '../shared/_formatted_datepicker.vue'
import flatPickr from 'vue-flatpickr-component';
import Vue from 'vue'
import { Upload } from 'ant-design-vue';
Vue.use(Upload)
import 'ant-design-vue/lib/select/style/index.css'
import 'ant-design-vue/lib/upload/style/index.css'
import edit_sending_school_modal from "./_edit_sending_school_modal.vue"
import TransferNewRequestReason from './_transfer_request_new_reason.vue';
import TranscriptUploadFile from './_upload_file.vue';

import VarsityInfoSection from './new_student_transfer/_varsity_info_section.vue';
import ParticipantAddressSection from './new_student_transfer/_participant_address_section.vue';
import HouseholdMembersInput from './new_student_transfer/_household_members_input.vue';
import NotesAndAgreement from './new_student_transfer/_notes_and_agreement.vue';

export default {
  components: {datepicker, flatPickr, edit_sending_school_modal, VarsityInfoSection, ParticipantAddressSection, TransferNewRequestReason, TranscriptUploadFile, HouseholdMembersInput, NotesAndAgreement},
  props: {
    registration: {
      type: Object,
      default(){
        return {}
      },
    },
    participants: {
      type: Array,
      default(){
        return []
      },
    },
    schools: {
      type: Array,
      default(){
        return []
      },
    },
  },
  data(){
    return {
      datePickerOpts: {enableTime: false, dateFormat: 'Y-m-d',altFormat: 'm-d-Y',altInput:true, wrap: true, altInputClass:"flatpckr"},
      gradedate: null,
      enddate: null,
      startDate: null,
      transfer_block: false, // already present
      showAdditionalFields: false,
      showAdditionalNoFields: false,
      previousSelectedName: null,
      receivingSelectedName: null,
      receivingSelectedNameOnParticipantSeeking: null,
      isPreviousSchoolClicked: false,
      isReceivingSchoolClicked: false,
      isReceivingSchoolClickedOnIsNotParticipantSeeking: false,
      showSeekingYesFields: false,
      showSeekingNoFields: false,
      currentModal: {
        show: false,
        title: '',
        object: {}
      },
      currentModalType: '',
      reason: '',
      selectedReason: null,
      nestedFieldValues: {} 
    }
  },
  computed: {
    receivingSchoolParticipantRules() {
      const isRequired = this.get_receiving_school_name_and_address.required;
      const isSelected = !!this.receivingSelectedName;

      return isRequired && !isSelected ? 'required' : '';
    },
    receivingSchoolRules() {
      const isRequired = this.get_receiving_school_name_and_address.required;
      const isSelected = !!this.receivingSelectedNameOnParticipantSeeking;

      return isRequired && !isSelected ? 'required' : '';
    },
    previousSchoolRules() {
      const isRequired = this.get_previous_school_name_and_address.required;
      const isSelected = !!this.previousSelectedName;
      return isRequired && !isSelected ? 'required' : '';
    },
    withdrawalDateModel: {
      get() {
        const data = this.registration.registration_transfers;
        return data.homeschooled_last_year === true
          ? data.homeschooled_last_year_yes_data.withdrawal_date.date
          : data.homeschooled_last_year_no_data.withdrawal_date.date;
      },
      set(value) {
        const data = this.registration.registration_transfers;
        if (data.homeschooled_last_year === true) {
          this.$set(data.homeschooled_last_year_yes_data, 'withdrawal_date', value);
        } else {
          this.$set(data.homeschooled_last_year_no_data, 'withdrawal_date', value);
        }
      }
    },
    varsityParticipation: {
      get() {
        return this.registration.registration_transfers.is_varsity_participation;
      },
      set(value) {
        this.$set(this.registration.registration_transfers, 'is_varsity_participation', value);
      }
    },
    get_previous_school_name_and_address(){
      return this.participants.find(
        x => x.uid === "previous_school_name_and_address"
      ) ?? {};
    },
    get_receiving_school_name_and_address(){
      return this.participants.find(
        x => x.uid === "receiving_school_name_and_address"
      ) ?? {};
    },
    get_date_entered_9th_grade() {
      return this.participants.find(
        x => x.uid === "date_participant_entered_9th_grade"
      );
    },
    get_sending_school_end_date() {
      return this.participants.find(
        x => x.uid === "date_of_withdrawal_from_previous_school"
      ) ?? {};
    },
    get_receiving_school_start_date() {
      return this.participants.find(
        x => x.uid === "date_of_enrollment_at_receiving_school"
      ) ?? {};
    },
    select_sending_school(){
      if(!this.registration.registration_sending_schools[0].name){
        return true
      }
      return false
    },
    activeReasons() {
      return this.registration.program.transfer_reasons.filter(reason => reason.active);
    },
    get_date_of_enrollment_at_receiving_school() {
      return this.participants?.find(
        x => x.uid === "date_of_enrollment_at_receiving_school"
      ) ?? {};
    },
    get_varsity_participation() {
      return this.participants?.find(
        x => x.uid === "played_varsity_after_9th_grade"
      ) ?? {};
    },

    get_varsity_sports_played() {
      const varsity_participation = this.get_varsity_participation;
      return varsity_participation?.nested_fields?.find(
        x => x.uid === "last_day_of_varsity_participation"
      ) ?? {};
    },

    get_participant_nested_fields() {
      const varsity_participation = this.get_varsity_participation;
      return varsity_participation?.nested_fields ?? [];
    },

    get_particiopant_address() {
      return this.get_participant_nested_fields.find(
        x => x.uid === "participant_address"
      ) ?? {};
    },

    get_people_participant_lived_with() {
      return this.get_participant_nested_fields.find(
        x => x.uid === "people_participant_lived_with"
      ) ?? {};
    },
    renderedReason() {
      const transfers = this.registration.registration_transfers;
      const hasReasons = this.activeReasons.length > 0;

      if (transfers.homeschooled_last_year === false && hasReasons) {
        return {
          dataKey: 'homeschooled_last_year_no_data',
          questionType: 'homeschooled_last_year_no'
        };
      }

      if (transfers.is_participant_seeking_to_participate === true && hasReasons) {
        return {
          dataKey: 'participant_seeking_yes_data',
          questionType: 'is_participant_seeking_to_participate_yes'
        };
      }

      if (transfers.is_participant_seeking_to_participate === false && hasReasons) {
        return {
          dataKey: 'participant_seeking_no_data',
          questionType: 'is_participant_seeking_to_participate_no'
        };
      }

      return null;
    }
  },
  mounted() {
    const isStudentTransfer = this.registration.program.organization.student_transfer
    if(isStudentTransfer){
      this.$set(this.registration, 'accept_transfer', true)
      this.transfer_block = true
    }
    if (this.registration.accept_transfer === true) {
      this.transfer_block = true;
    } else if (this.registration.accept_transfer === false) {
      this.transfer_block = false;
    }

    const homeschooled = this.registration.registration_transfers?.homeschooled_last_year;
    if (homeschooled === true) {
      this.showAdditionalFields = true;
      this.showAdditionalNoFields = false;
    } else if (homeschooled === false) {
      this.showAdditionalFields = false;
      this.showAdditionalNoFields = true;
    } else {
      this.showAdditionalFields = false;
      this.showAdditionalNoFields = false;
    }
    const noData = this.registration.registration_transfers?.homeschooled_last_year_no_data || {};
    this.previousSelectedName = noData.previous_school?.name
    this.receivingSelectedName = noData.receiving_school?.name
    const noDataSeeking = this.registration.registration_transfers?.participant_seeking_no_data || {};
    this.receivingSelectedNameOnParticipantSeeking = noDataSeeking.receiving_school
  },
  methods: {
    async validateTransferFields() {
      let dateValid = true;

      if (this.get_date_entered_9th_grade?.required) {
        dateValid = await this.$refs.date_participant_entered_9th_grade?.validate?.();
      }
      return dateValid;
    },
    onChangeReason(event) {
      const selectedName = event.target.value;
      this.selectedReason = this.activeReasons.find(r => r.name === selectedName) || null;
    },
    openSchoolModal(type) {
      this.currentModalType = type;
      this.currentModal.object = {};
      this.currentModal.show = true;

      if (type === 'previous') {
        this.currentModal.title = "Previous School";
        this.isPreviousSchoolClicked = true;
      } else if (type === 'receiving') {
        this.currentModal.title = "Receiving School";
        this.isReceivingSchoolClicked = true;
      } else if (type === 'is_not_participant_seeking_receiving') {
        this.currentModal.title = "Receiving School";
        this.isReceivingSchoolClickedOnIsNotParticipantSeeking = true;
      }
    },
    handleNameSelected(type, name) {
      if (type === 'previous') {
        this.previousSelectedName = name; // store full object
        this.isPreviousSchoolClicked = false;
        this.registration.registration_transfers.homeschooled_last_year_no_data.previous_school.name = this.previousSelectedName;
      } else if (type === 'receiving') {
        this.receivingSelectedName = name;
        this.isReceivingSchoolClicked = false;
        this.registration.registration_transfers.homeschooled_last_year_no_data.receiving_school.name = this.receivingSelectedName;
      } else if (type === 'is_not_participant_seeking_receiving') {
        this.receivingSelectedNameOnParticipantSeeking = name;
        this.registration.registration_transfers.participant_seeking_no_data.receiving_school = this.receivingSelectedNameOnParticipantSeeking;
        this.isReceivingSchoolClickedOnIsNotParticipantSeeking = false;
      }
      this.currentModal.show = false;
    },
    clearSelectedName(type) {
      if (type === 'previous') {
        this.previousSelectedName = null;

        if (!this.registration.registration_transfers.homeschooled_last_year_no_data.previous_school) {
          this.$set(this.registration_transfers.homeschooled_last_year_no_data, 'previous_school', {});
        }

        this.$set(this.registration.registration_transfers.homeschooled_last_year_no_data.previous_school, 'name', null);

      } else if (type === 'receiving') {
        this.receivingSelectedName = null;

        if (!this.registration.registration_transfers.homeschooled_last_year_no_data.receiving_school) {
          this.$set(this.registration.registration_transfers.homeschooled_last_year_no_data, 'receiving_school', {});
        }

        this.$set(this.registration.registration_transfers.homeschooled_last_year_no_data.receiving_school, 'name', null);

      } else if (type === 'is_not_participant_seeking_receiving') {
        this.receivingSelectedNameOnParticipantSeeking = null;
      }
    },
    onHomeschooledChange(event) {
      const value = event.target.value;
      this.registration.registration_transfers.homeschooled_last_year = value === 'yes';
      this.showAdditionalFields = value === 'yes';
      this.showAdditionalNoFields = value === 'no';
      this.$nextTick(() => {
        this.$refs.homeschooled_last_year?.validate?.();
      });
    },
    onSeekingToParticipateChange(event) {
      const value = event.target.value;
      this.registration.registration_transfers.is_participant_seeking_to_participate = value === 'yes';
      this.$nextTick(() => {
        this.$refs.is_participant_seeking_to_participate?.validate?.();
      });
    },
    onVarsityToParticipateChange() {
      this.$nextTick(() => {
        if (this.$refs.is_varsity_participation) {
          this.$refs.is_varsity_participation.validate();
        }
      });
    },
    onTransferChange(event) {
      const value = event.target.value;
      if (value === "disable") {
        this.$set(this.registration, 'accept_transfer', true);
        this.transfer_block = true;
      } else {
        this.$set(this.registration, 'accept_transfer', false);
        this.transfer_block = false;
        this.showAdditionalFields = false; // Reset sub-visibility
      }
      this.$refs.accept_transfer.errors = [];
    },

    onSelectDate(date, type) {
      const selectedDate = Array.isArray(date) ? date[0] : date;
      const formattedDate = moment(selectedDate).format('YYYY-MM-DD');

      if (type === 'yes_withdrawal') {
        this.registration.registration_transfers.homeschooled_last_year_yes_data.withdrawal_date.date = formattedDate;
        return;
      }

      if (type === 'no_withdrawal') {
        this.registration.registration_transfers.homeschooled_last_year_no_data.withdrawal_date.date = formattedDate;
        return;
      }
      if (type === 'enrollment') {
        this.registration.registration_transfers.participant_seeking_no_data.enrollment_date = formattedDate;
        return;
      }
      const transfer_id = (
        type === 'grade' ? this.get_date_entered_9th_grade?.id :
        type === 'desired' ? this.get_desired_new_school_start_date?.id :
        type === 'enrollment' ? this.get_date_of_enrollment_at_receiving_school?.id :
        this.get_sending_school_end_date?.id
      );

      const student_transfer = this.registration.registration_student_transfers.find(
        x => x.student_transfer_id == transfer_id
      );

      if (!student_transfer || !student_transfer.data) {
        console.warn("student_transfer is undefined or missing data for type:", type);
        return;
      }

      this.$set(student_transfer.data, 0, formattedDate);
    }
  }
}
</script>
<style scoped>
.label-text{
  margin-right: 1rem;
}
::v-deep(.input-group input[type="text"]) {
  padding-left: 1rem !important;
}
</style>